<!--
 * @Author: your name
 * @Date: 2022-02-22 17:14:01
 * @LastEditTime: 2022-02-23 16:07:38
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /demander-manage/src/components/footer/index.vue
-->
<template>
  <!-- 底栏容器 -->
  <div id="footerContent">
    <div class="describe">
      <span>
        <svg-icon icon-class="describe1" />
        全场正品
      </span>
      <span>
        <svg-icon icon-class="describe2" />
        专属客服
      </span>
      <span>
        <svg-icon icon-class="describe3" />
        平台配送
      </span>
      <span>
        <svg-icon icon-class="describe4" />
        贴心服务
      </span>
      <span>
        <svg-icon icon-class="describe5" />
        售后服务
      </span>
    </div>
    <el-divider />
    <div class="helpCenter">
      <ul class="leftHelp">
        <span v-for="(t,i) in footerlist" :key="i">
          <li v-if="i < 3">
            <h3 @click="dataOne(t)">{{ t.fdocTitle }}</h3>
            <p v-for="(item,index) in t.details" :key="index" @click="itemClick(item,t)">
              {{ item.fdocName }}
            </p>
          </li>
        </span>
      </ul>
      <div class="rightIcon">
        <img width="256px" height="74px;" :src="logo" alt="">
        <p>
          <svg-icon icon-class="fPhone" />0570-3088009
        </p>
      </div>
    </div>
    <el-divider id="bottomDivider" />
    <div class="copyright">
      <span style="padding-bottom: 20px;display: block;">违法和不良信息、未成年人保护举报电话：0570-3088009&nbsp;网上有害信息举报</span>
     
      COPYRIGHT@ 2013 - 至今 RIGHTS RESERVED.版权所有实达实商城 浙ICP备13034076号-1
      <div class="imgBox">
        <img src="../../assets/images/copyright1.png" alt="">
        <img src="../../assets/images/copyright2.png" alt="">
        <img src="../../assets/images/copyright3.png" alt="">
        <img src="../../assets/images/copyright4.png" alt="">
        <img src="../../assets/images/copyright5.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
// import YButton from '/components/YButton'
import { footerOne } from '@/api/footer'
import logoimg from '@/assets/images/logoimg.png'
import {
  getIndexShopDecoration
} from '@/api/home'
export default {
  components: {
    // YButton
  },
  data() {
    return {
      footerlist: [],
      footerTwo: [],
      logo: ''
    }
  },
  mounted() {
    this.getFotterOne()
    this.getLogo()
  },
  methods: {
    // 首页模块
    getLogo() {
      const id = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).funitID : ''
      const params = {
        'modelID': 1,
        'fDemandUnitId': id
      }
      getIndexShopDecoration(params).then((res) => {
        this.plateData = res.classification
        this.logo = res.malllogo.length ? (res.malllogo[0].FImagePath ? res.malllogo[0].FImagePath : logoimg) : logoimg
      })
        .catch(() => {
          this.logo = logoimg
        })
    },
    getFotterOne() {
      footerOne({}).then((res) => {
        this.footerlist = res.rows
        res.rows.map((item) => {
          this.footerTwo.push({
            title: item.fdocTitle,
            conton: item.details
          })
        })
      })
    },
    dataOne(item) {
      const loginVue = JSON.parse(sessionStorage.getItem('vuex'))
      if (loginVue.user.token) {
        this.$router.push({
          path: '/help',
          query: {
            data: item.fdocTitle
          }
        })
      } else {
        this.$router.push({
          path: 'login/login'
        })
      }
    },
    itemClick(it, item) {
      const loginVue = JSON.parse(sessionStorage.getItem('vuex'))
      if (loginVue.user.token) {
        this.$router.push({
          path: '/help',
          query: {
            fTitle: item.fdocTitle,
            id: it.fid
          }
        })
      } else {
        this.$router.push({
          path: 'login/login'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#footerContent {
    width: 1220px;
    margin: 0 auto;
    padding-top: 35px;
    background: #E1E1E1;
    #bottomDivider {
        margin: 30px 0;
    }
    .copyright {
        font-size: 16px;
        color: #666666;
        text-align: center;
        .imgBox {
            margin: 20px 0;
            :nth-last-child(1) {
                margin-right: 0;
            }
            img {
                height: 64px;
                margin-right: 15px;

            }
        }
    }
    .helpCenter {
        position: relative;
        min-height: 130px;
        overflow: hidden;
        .rightIcon {
            position: absolute;
            right: 0;
            top: 0;
            font-size: 22px;
            font-weight: bold;
            color: #EC212D;
            text-align: right;
            .svg-icon {
                font-size: 18px;
                margin-right: 10px;
            }
            p {
                margin-top: 15px;
            }
        }
        .leftHelp {
            width: 965px;
            overflow: hidden;
            >span {
                display: inline-block;
                vertical-align: top;
            }
            li {
                margin-right: 100px;
                h3 {
                    cursor: pointer;
                    font-size: 20px;
                    color: #333333;
                    margin-bottom: 16px;
                    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
                }
                p {
                    cursor: pointer;
                    font-size: 16px;
                    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                    margin-bottom: 20px;

                }
                p:hover {
                    color: #EC212D;
                }
            }
        }
    }
    .el-divider--horizontal {
        margin: 32px 0 38px;
        background-color: #D2D2D2;
    }
    .describe {
        font-size: 24px;
        font-family: Microsoft YaHei-Bold, Microsoft YaHei;
        font-weight: bold;
        color: #222222;
        >span {
            display: inline-block;
            margin-right: 77px;
        }
        :nth-last-child(1) {
            margin-right: 0;
        }
        .svg-icon {
            font-size: 60px;
            vertical-align: middle;
            margin-right: 18px;
        }
    }
}
</style>
